import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-su_011",
  "use": "icon-su_011-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-su_011\"><defs><style>#icon-su_011 .cls-1{fill:none;opacity:0;}</style></defs><g id=\"icon-su_011_レイヤー_2\" data-name=\"レイヤー 2\"><g id=\"icon-su_011_icon\"><rect class=\"cls-1\" width=\"24\" height=\"24\" /><polygon class=\"cls-2\" points=\"20 11 13 11 13 4 11 4 11 11 4 11 4 13 11 13 11 20 13 20 13 13 20 13 20 11\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol